<div id="user-data-container">
  <section>
    <nes-heading tag="h1" size="6xl" [cypress]="'page_title'" class="nes-mb-3">
      {{ "USER_DATA.TITLE" | translate }}
    </nes-heading>
    <nes-text class="nes-mb-5">{{ "USER_DATA.SUB_TEXT" | translate }}</nes-text>
  </section>
  <ng-container *ngIf="selectedProduct$ | async as selectedProduct">
    <section *ngIf="(totalProductCount$ | async) > 1" class="mb-3">
      <nes-heading
        tag="h2"
        size="4xl"
        class="headingS"
        [cypress]="'product_title'"
      >
        <strong>{{
          "COMPOSE.PRODUCTS_OVERVIEW.PRODUCTS." +
            selectedProduct.identifier +
            ".TITLE" | translate
        }}</strong>
      </nes-heading>
      <div *ngIf="selectedProduct.route as route">
        {{ route.from.naam }} - {{ route.to.naam }}
      </div>
      <nes-text>
        {{ selectedProduct | displayServices | async }}
      </nes-text>
    </section>
    <section class="animated fadeIn">
      <form
        [formGroup]="formGroup"
        (focusin)="onFirstInteraction($event)"
        id="user_data_name"
        name="user_data_name"
      >
        <div class="formfield">
          <nes-text class="nes-mb-2" weight="bold" color="blue" size="md">
            {{ "INPUT.GENDER.LABEL" | translate }}
          </nes-text>

          <ul [cypress]="'gender'" class="list formfield__inputGroup">
            <li
              *ngFor="let gender of genders"
              class="list__item formfield__inputGroupItem"
            >
              <div class="radioButton">
                <input
                  [id]="'gender_' + gender.value"
                  [formControl]="getControl('gender')"
                  [value]="gender.value"
                  [cypress]="gender.value"
                  type="radio"
                  class="radioButton__input"
                  name="gender"
                  privacySensitive
                />
                <label
                  class="radioButton__label"
                  [for]="'gender_' + gender.value"
                  tabindex="-1"
                >
                  {{ gender.displayText | translate }}
                </label>
              </div>
            </li>
          </ul>

          <div *ngIf="getGenderErrorKey() !== undefined">
            <ng-container>
              <nes-error-message>
                {{ getGenderErrorKey() }}
              </nes-error-message>
            </ng-container>
          </div>
        </div>

        <div class="formfield">
          <nes-input
            [label]="'INPUT.INITIALS.LABEL' | translate"
            [name]="'INPUT.INITIALS.NAME' | translate"
            [value]="formGroup.get('initials')!.value"
            [formControl]="getControl('initials')"
            formControlName="initials"
            required
            (nesOnKeyDown)="_uiService.isOnlyLettersInInitials($event)"
            [cypress]="'initials'"
            nes-id="initials"
            id="initials"
            maxLength="10"
            [error]="getInitialsErrorKey()"
            nesFormControl
            receiptFooterVisibility
            formatInitials
            formatInitialsIE
            privacySensitive
            controlled
            type="text"
          ></nes-input>
        </div>

        <bca-middle-name
          [userForm]="formGroup"
          [middleNames]="middleNames$ | async"
        >
        </bca-middle-name>

        <div class="formfield">
          <nes-input
            [label]="'INPUT.LASTNAME.LABEL' | translate"
            [name]="'INPUT.LASTNAME.NAME' | translate"
            [value]="formGroup.get('lastName')!.value"
            formControlName="lastName"
            [formControl]="getControl('lastName')"
            nesFormControl
            controlled
            [cypress]="'last_name'"
            required
            receiptFooterVisibility
            privacySensitive
            maxLength="40"
            [error]="getLastNameErrorKey()"
            [forceUppercase]="{ firstLetterOnly: true }"
            nes-id="last_name"
            type="text"
            (nesOnKeyDown)="_uiService.isIgnoreNumbersInLastName($event)"
          ></nes-input>
        </div>

        <bca-choose-birth-date
          [selectedDate]="(selectedBirthDate$ | async)?.dateString"
          [dateRequiredError]="
            isTouchedAndDirty('birthDate') && hasError('birthDate', 'required')
          "
          [dateValidError]="
            isTouchedAndDirty('birthDate') &&
            hasError('birthDate', 'dateValidator')
          "
          [dateAgeError]="
            isTouchedAndDirty('birthDate') &&
            hasError('birthDate', 'ageValidator')
          "
          (dateStringSelected)="selectedABirthdate($event)"
          (dateSelected)="onBirthDateSelected($event)"
        >
        </bca-choose-birth-date>

        <div class="formfield">
          <nes-input
            [label]="'INPUT.EMAIL.LABEL' | translate"
            [name]="'INPUT.EMAIL.NAME' | translate"
            [value]="formGroup.get('email')!.value"
            formControlName="email"
            [formControl]="getControl('email')"
            nesFormControl
            controlled
            [cypress]="'email'"
            receiptFooterVisibility
            privacySensitive
            forceLowercase
            noSpace
            required
            [error]="getEmailErrorKey()"
            maxLength="50"
            nes-id="email"
            type="email"
          ></nes-input>
        </div>

        <bca-choose-country
          [userForm]="formGroup"
          [selectedCountryCode]="selectedCountryCode$ | async"
          [countries]="countries$ | async"
          (selected)="onCountrySelected($event, selectedProduct)"
        >
        </bca-choose-country>

        <bca-user-address
          [addressForm]="getControl('address')"
          [postcodeLength]="(selectedCountrySettings$ | async)?.postcodeLength"
          [searchableAddress]="
            (selectedCountrySettings$ | async)?.searchableAddress
          "
          [searchFailed]="addressSearchFailed$ | async"
          [addressLoading]="addressLoading$ | async"
          [manualMode]="addressManualMode$ | async"
          (search)="onAddressSearch($event)"
          (manual)="onAddressManual(selectedProduct, $event)"
          [isMobileView]="mobileQueryMatches$ | async"
        >
        </bca-user-address>

        <ng-container *ngIf="selectedProduct.needsPhoto">
          <bca-choose-image
            [imageRequiredError]="
              isTouchedAndDirty('image') && hasError('image', 'required')
            "
            [selectedFaceImage]="selectedFaceImage$ | async"
            (openDialog)="onImageDialogOpened()"
            (delete)="onImageDelete()"
          >
          </bca-choose-image>
        </ng-container>

        <bca-use-product
          [selectedProductUsage]="(selectedUseProduct$ | async)?.type"
          [selectedProductUsageDate]="(selectedUseProduct$ | async)?.date"
          (dateSelected)="onProductUsageDateSelected($event)"
          (selected)="onProductUsageSelected($event)"
        >
        </bca-use-product>

        <a
          (click)="previousRoute()"
          [cypress]="'previous_page'"
          class="backArrowLink backArrowLink--button actionBar__item"
        >
          <span class="backArrowLink__text">{{
            "BUTTON.BACK" | translate
          }}</span>
        </a>

        <div
          class="nes-flex nes-justify-between nes-items-center nes-flex-wrap"
        >
          <nes-button
            variant="tertiary"
            icon-leading="plus-circle"
            [disabled]="!(allowNewProduct$ | async)"
            type="button"
            (click)="addNewProduct()"
          >
            {{ "BUTTON.ADD_PRODUCT" | translate }}
          </nes-button>
          <nes-button
            nes-id="to_company_page"
            id="to_company_page"
            variant="brand"
            [cypress]="'next_page'"
            type="button"
            (nesOnClick)="formSubmit()"
          >
            <span class="s-hidden m-visible">
              {{ "BUTTON.CONTINUE_DESKTOP" | translate }}
            </span>
            <span class="s-visibile m-hidden">
              {{ "BUTTON.CONTINUE_MOBILE" | translate }}
            </span>
          </nes-button>
        </div>
      </form>
    </section>
  </ng-container>
</div>
